import {useDebugValue}from'react';import {useParams}from'react-router-dom';import {normalizeRealm}from'../utils/realmUtils.js';function useRealm() {
  var _useParams = useParams(),
    realm = _useParams.realm;
  var normalizedRealm = normalizeRealm(realm);
  useDebugValue(normalizedRealm);
  return normalizedRealm;
}export{useRealm as default};